import React from "react";
import { Flex } from "@chakra-ui/react";
import Head from "../components/Head";
import { Large } from "../components/Type";
import { FaqQuestions } from "../faq";
import { loadCatalog } from "../i18n";
import { Trans, t, msg } from "@lingui/macro";

export async function getStaticProps({ params, ...ctx }) {
  const translation = await loadCatalog(ctx.locale);
  return { props: { translation } };
}

const FAQ = ({ translation }) => {
  return (
    <>
    <Head title={t`Bantuan dan FAQ`} description={t`Pusat Bantuan Saweria menyediakan panduan lengkap, FAQ, dan solusi untuk membantu kamu menggunakan platform dengan lebih mudah.`} />
    <Flex direction="column" marginX={["1em", "3em"]}>
      <Large mt="1em" mb="1em">
        <Trans>Frequently Asked Questions:</Trans>
      </Large>
      <FaqQuestions></FaqQuestions>
    </Flex>
    </>
  );
};

export default FAQ;
